// extracted by mini-css-extract-plugin
export default {"legend":"Mqa-z","legendSpacing":"Nqa-z"};